"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DiscontinuousLineComponent = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _palette = require("../../../styles/palette");

var _style = require("./style");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DiscontinuousLine = function (_PureComponent) {
  (0, _inherits2["default"])(DiscontinuousLine, _PureComponent);

  var _super = _createSuper(DiscontinuousLine);

  function DiscontinuousLine() {
    var _temp, _this;

    (0, _classCallCheck2["default"])(this, DiscontinuousLine);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return (0, _possibleConstructorReturn2["default"])(_this, (_temp = _this = _super.call.apply(_super, [this].concat(args)), _this.draw = function () {
      var _assertThisInitialize = (0, _assertThisInitialized2["default"])(_this),
          canvas = _assertThisInitialize.canvas,
          ctx = _assertThisInitialize.ctx,
          _assertThisInitialize2 = _assertThisInitialize.props,
          margin = _assertThisInitialize2.margin,
          color = _assertThisInitialize2.color,
          length = _assertThisInitialize2.length,
          direction = _assertThisInitialize2.direction;

      if (canvas && direction === 'vertical') {
        var _canvas$parentNode$ge = canvas.parentNode.getBoundingClientRect(),
            height = _canvas$parentNode$ge.height;

        canvas.width = 1;
        canvas.height = height + margin + length;
        ctx.lineWidth = 2;
        ctx.strokeStyle = color;
        ctx.setLineDash([10, 8]);
        ctx.beginPath();
        ctx.moveTo(1, margin);
        ctx.lineTo(1, canvas.height);
        ctx.stroke();
      } else if (canvas && direction === 'horizontal') {
        var _canvas$parentNode$pa = canvas.parentNode.parentNode.getBoundingClientRect(),
            width = _canvas$parentNode$pa.width;

        canvas.width = width + length;
        canvas.height = margin;
        ctx.lineWidth = 1;
        ctx.strokeStyle = color;
        ctx.setLineDash([10, 8]);
        ctx.beginPath();
        ctx.moveTo(0, margin);
        ctx.lineTo(canvas.width, margin);
        ctx.stroke();
      }
    }, _temp));
  }

  (0, _createClass2["default"])(DiscontinuousLine, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ctx = this.canvas.getContext('2d');
      setImmediate(this.draw);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      setImmediate(this.draw);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          _this$props$className = _this$props.className,
          line = _this$props$className.line,
          discontinuousVerticalLine = _this$props$className.discontinuousVerticalLine,
          childrenStyle = _this$props$className.childrenStyle;
      return _react["default"].createElement(_style.DiscontinuousVerticalLine, {
        className: discontinuousVerticalLine
      }, _react["default"].createElement(_style.Line, {
        className: line,
        ref: function ref(canvas) {
          _this2.canvas = canvas;
        }
      }), _react["default"].createElement(_style.Children, {
        className: childrenStyle
      }, children));
    }
  }]);
  return DiscontinuousLine;
}(_react.PureComponent);

DiscontinuousLine.propTypes = {
  children: _propTypes["default"].node,
  color: _propTypes["default"].string,
  direction: _propTypes["default"].string,
  margin: _propTypes["default"].number,
  length: _propTypes["default"].number,
  className: _propTypes["default"].shape({})
};
DiscontinuousLine.defaultProps = {
  margin: 0,
  length: 0,
  color: _palette.palette.disabled,
  className: {
    discontinuousVerticalLine: '',
    line: '',
    childrenStyle: ''
  },
  direction: 'vertical'
};
var DiscontinuousLineComponent = DiscontinuousLine;
exports.DiscontinuousLineComponent = DiscontinuousLineComponent;
var _default = DiscontinuousLine;
exports["default"] = _default;